import React from 'react';
import { Tooltip } from 'antd';
import { FilterOutlined, FunnelPlotOutlined } from '@ant-design/icons';
import { tI } from '../../../translate';
import { Catcher } from '../../Catcher';
import ViewStyles from '../../styles/m_viewStyles.less';

export const customFilterIcon = (filtered: boolean): JSX.Element => {
    return (
        <Catcher>
            <Tooltip title={tI('Click to filter')}>
                {filtered ? (
                    <FunnelPlotOutlined className={ViewStyles.customFilterIcon} />
                ) : (
                    <FilterOutlined className={ViewStyles.customFilterIcon} />
                )}
            </Tooltip>
        </Catcher>
    );
};
